import { RootState } from '../store';

// All selectors access fields directly from state (not nested under userDetails)

export const selectUserDetails = (state: RootState) => ({
  user_id: state.auth.user_id,
  organization_id: state.auth.organization_id,
  organization_name: state.auth.organization_name,
  logo: state.auth.logo,
  role: state.auth.role,
  outlets: state.auth.outlets,
});

export const selectSession = (state: RootState) => state.auth.session;

export const selectUserRole = (state: RootState) => state.auth.role;

export const selectOutlets = (state: RootState) => state.auth.outlets;

export const selectOrganizationId = (state: RootState) => state.auth.organization_id;

export const selectUserId = (state: RootState) => state.auth.user_id;

export const selectOrganizationName = (state: RootState) => state.auth.organization_name;

export const selectLogo = (state: RootState) => state.auth.logo;

export const selectIsLoading = (state: RootState) => state.auth.isLoading;

export const selectError = (state: RootState) => state.auth.error;
